import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";

function ForgotPassword() {
  const { t } = useApp();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async e => {
    e.preventDefault(); setError(""); setBusy(true);
    try {
      await axios.post("/api/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong.");
    } finally { setBusy(false); }
  };

  return (
    <section className="section container">
      <div className="auth-wrap">
        <div className="center" style={{ marginBottom: 24 }}>
          <span className="eyebrow">{t("memberAccess")}</span>
          <h1 className="section-title">{t("forgotTitle")}</h1>
          <p style={{ color: "var(--muted)", marginTop: 8 }}>{t("forgotSub")}</p>
        </div>
        <div className="card-panel">
          {done ? (
            <div style={{ textAlign: "center", padding: "12px 0" }}>
              <div className="alert alert-success">{t("resetSent")}</div>
              <Link to="/login" style={{ marginTop: 16, display: "inline-block" }}>{t("backToLogin")}</Link>
            </div>
          ) : (
            <form onSubmit={onSubmit}>
              {error && <div className="alert alert-error">{error}</div>}
              <div className="field">
                <label>{t("email")}</label>
                <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
              </div>
              <button className="btn btn-primary btn-lg btn-block" type="submit" disabled={busy}>
                {busy ? t("sending") : t("sendResetLink")}
              </button>
              <p className="hint center" style={{ marginTop: 14 }}>
                <Link to="/login">{t("backToLogin")}</Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
export default ForgotPassword;
